
import { AssignmentServiceResponse, AssignTransportToStation, AvailableTransports, AvailableTransportsSelection, CancellationStation, CancelTransport, SendTransportToStation, SetProcessingStatus, StructureSelection, SuspendStation, TransportStationAssignment } from '../model/sac-client.model';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ServiceResponse } from '@sdbn/appclient';
import { Identity } from '@sdbn/appclient';


@Injectable({
  providedIn: 'root'
})
export class SacClientService {

  constructor(
    private httpService: HttpService
  ) { }

  public loadAvailableTransports(selection: AvailableTransportsSelection): Observable<AvailableTransports> {
    return this.httpService.postWithContext<AvailableTransports>(environment.sacClientEndpoint + '/available-transports', selection).pipe(
      map(
        at => new AvailableTransports(at)
      )
    );
  }

  public cancelTransport(action: CancelTransport): Observable<ServiceResponse> {
    const url = `${environment.sacClientEndpoint}/cancel`;
    return this.httpService.postWithContext<ServiceResponse>(url, action);
  }

  public sendTransportToStation(action: SendTransportToStation): Observable<AssignmentServiceResponse> {
    const url = `${environment.sacClientEndpoint}/send`;
    return this.httpService.postWithContext<AssignmentServiceResponse>(url, action).pipe(
      map(sr => new AssignmentServiceResponse(sr))
    );
  }

  public getStationsForCancellation(assignment: TransportStationAssignment): Observable<Array<CancellationStation>> {
    const url = `${environment.sacClientEndpoint}/cancellation-stations`;
    return this.httpService.postWithContext<Array<CancellationStation>>(url, assignment).pipe(
      map(
        r => r.map(cs => new CancellationStation(cs))
      )
    );
  }

  public setProcessingStatus(request: SetProcessingStatus) {
    const url = `${environment.sacClientEndpoint}/set-processing-status`;
    return this.httpService.postWithContext<ServiceResponse>(url, request);
  }

  public callTransportToStation(assignment: TransportStationAssignment): Observable<any> {
    const url = `${environment.sacClientEndpoint}/call-transport`;
    return this.httpService.postWithContext<any[]>(url, assignment);
  }

  public suspendStation(action: SuspendStation): Observable<ServiceResponse> {
    const url = `${environment.sacClientEndpoint}/suspend-station`;
    return this.httpService.postWithContext<ServiceResponse>(url, action);
  }

  public endStationSuspension(identity: Identity): Observable<ServiceResponse> {
    const url = `${environment.sacClientEndpoint}/end-station-suspension`;
    return this.httpService.postWithContext<ServiceResponse>(url, identity);
  }

}
